import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const RightPanel = () => {
    document.title = "Sağ panel";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Sağ panel", value: "/cash/rightpanel", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sağ panel</h2>
                    <p>
                        Kassa proqramında interfeysin sağ yuxarı hissəsi
                        <ol>
                            <li>
                                <Button>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16">
                                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"></path>
                                    </svg>
                                </Button>{" "}
                                Düyməsi növbədəki əməliyyatların sayınının göstəricisidir. Müəyyən zaman ərzində həmin əməliyyatlar ümumi məlumat bazasına
                                göndərilir
                            </li>
                            <li>
                                <Button>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-arrow-repeat"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"></path>
                                        <path
                                            fill-rule="evenodd"
                                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                                        ></path>
                                    </svg>
                                </Button>{" "}
                                Düyməsi ilə məlumat bazasında olan dəyişiklikləri manual olaraq yenilənmə barədə sorğu göndərmək üçün nəzərdə tutulub. Bu düymə
                                sıxılmasa, 10 dəqiqə intervalında yenilənmə barədə sorğu avtomatik olaraq icra olunur
                            </li>
                            <li>
                                <Button>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" class="bi bi-wifi" viewBox="0 0 16 16">
                                        <path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"></path>
                                        <path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"></path>
                                    </svg>
                                </Button>{" "}
                                İnternet Şəbəkəsi ilə əlaqənin göstəricisidir. Əlaqə olduqda yaşıl, olmadıqda isə qırmızı rəngdə olacaq
                            </li>
                            <li>
                                <div className="d-flex align-items-center">
                                    <div
                                        style={{
                                            background: "var(--dark-blue)",
                                            height: "35px",
                                            width: "35px",
                                            borderRadius: "25px",
                                            color: "#fff",
                                            textAlign: "center",
                                            paddingTop: "4px",
                                            marginRight: "6px",
                                        }}
                                    >
                                        Ə
                                    </div>{" "}
                                    Düyməsi kassa balansı və istifadəçi barədə məlumatların ək olunduğu pəncərəni açmaq üçün nəzərdə tutulub
                                </div>
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/rightpanel.gif" alt="Sağ panel" />
                </article>
            </div>
        </div>
    );
};
